import {css} from 'lit'; export default css`:host{position:relative;z-index:var(--goto-z-index-modal)}`;
    